import type { Products } from "../types"

export const products: Products = new Map([
  [
    "frontier-etherfi",
    {
      name: "Frontier Ether.fi",
      entity: ["euler-dao"],
      vaults: [
        "0xE220d93e73D22e72Cb3f7B2496B4c2e6DfEd8B72",
        "0x5097DaacD8198a164257B6AAB66951323e53EE53",
        "0xfeE02E3904DfcF323851163E3b8847952f168b2e",
      ],
      isGovernanceLimited: true,
    },
  ],
  [
    "frontier-ethena",
    {
      name: "Frontier Ethena",
      entity: ["euler-dao"],
      vaults: [
        "0x87Ca725845824903B29a03ADFDF1548Cd1D30a4f",
        "0x36313192157C38A16e197f48c80346849AE3957A",
        "0xB0004aD99F0e383cC413bA69ACff7c229D930112",
      ],
      isGovernanceLimited: true,
    },
  ],
  [
    "re7labs-ethena",
    {
      name: "Re7 Labs Ethena",
      entity: ["re7-labs"],
      vaults: [
        "0x36e62e73DF0fE8e68280a93AD2F2d20CA25D0eF3",
        "0xa61dcB570c7C728F992417bf20e8F56f2669A46C",
      ],
      externalVaults: ["0x8Cd0DE6204176600918dA79eC70d0d9F4c2588e3"],
    },
  ],
  [
    "re7labs-usdt0",
    {
      name: "Re7 Labs USDT0",
      entity: ["re7-labs"],
      vaults: [
        "0x8Cd0DE6204176600918dA79eC70d0d9F4c2588e3",
        "0x729b92Cfea63CB238199eA61a01eA510D80fa444",
      ],
      externalVaults: [
        "0x36e62e73DF0fE8e68280a93AD2F2d20CA25D0eF3",
        "0xa61dcB570c7C728F992417bf20e8F56f2669A46C",
        "0x7760dBA44A3b9dC740F8Ac3e49AFb66f1EC46834",
      ],
    },
  ],
  [
    "re7labs-weth",
    {
      name: "Re7 Labs WETH",
      entity: ["re7-labs"],
      vaults: [
        "0x7760dBA44A3b9dC740F8Ac3e49AFb66f1EC46834",
        "0xa4a52AF57D8FD82FC827E5E400007ab65CEf271b",
      ],
    },
  ],
  [
    "re7labs-xusd",
    {
      name: "Re7 Labs xUSD",
      entity: ["re7-labs"],
      vaults: [],
      deprecatedVaults: [
        "0xF675FBe777E992f5D5D84AdF41161dC0f20104a6",
        "0x8AdB906421f65C27155f44f1829Ca1E5B024c3F6",
      ],
    },
  ],
  [
    "k3-capital-usdai",
    {
      name: "K3 Capital USDai Market",
      entity: "k3",
      vaults: [
        "0x767d33217e7d2670695FfE2a104548B780f4F5d8",
        "0xAADEA03f6D6F198Bdc9229bD8113aceD19031773",
        "0x141A6f77ca186861BFB323b07012e80Ef4e09041",
      ],
    },
  ],
  [
    "frontier-plasma",
    {
      name: "Frontier Plasma",
      entity: ["euler-dao"],
      vaults: [
        "0x79C86345c5132465DdebB7dC90de0f826Fb905b1",
        "0x969a9d7e07Dd584e5b989FE63ac202c4C2372Fd4",
        "0x7f801a8f69C9D9BA52aF27A8fADde56FC33F9267",
      ],
      isGovernanceLimited: true,
    },
  ],
  [
    "frontier-maple",
    {
      name: "Frontier Maple",
      entity: ["euler-dao"],
      vaults: [
        "0x5398657d46499D31863A404bbedc738bDa812424",
        "0xFA00aBfF8E404B4Fe939115409035F708a109842",
      ],
      isGovernanceLimited: true,
    },
  ],
  [
    "frontier-resolv-wstusr",
    {
      name: "Frontier Resolv wstUSR",
      entity: ["euler-dao"],
      vaults: [
        "0xAc40D41aB11b0eb991a7D34D55DbDbB7849e92EF",
        "0x2beBDc03D4268247c205ECB6926332221EC612AC",
        "0x4718484ac9dc07fbbC078561e8f8Ef29e2a369CD",
      ],
      isGovernanceLimited: true,
    },
  ],
  [
    "frontier-resolv-rlp",
    {
      name: "Frontier Resolv RLP",
      entity: ["euler-dao"],
      vaults: [
        "0x0a39a99f1639a9e26ED9F7c096165A41FDEb5E63",
        "0xbd2D9A3c34f866387a371035dc94Cbe94759E6d8",
        "0x538f01e0BA3cf3aB5b3837A0d138a3F67b9b8235",
      ],
      isGovernanceLimited: true,
    },
  ],
  [
    "telosc-stream",
    {
      name: "TelosC Stream",
      description:
        "A market tailored to the Stream ecosystem. Governed and curated by TelosC.",
      entity: "telosc",
      vaults: [],
      deprecatedVaults: [
        "0x57c582346B7d49A46Af3745A8278917D1c1311b8",
        "0xF90Cf999dE728A582e154F926876b70e93a747B7",
        "0x27934d4879fc28a74703726eDae15F757E45A48a",
        "0x138c289Bb8b855CF271305C8bcf91DC31Ba30194",
      ],
    },
  ],
  [
    "edge-capital-core-cluster",
    {
      name: "Edge UltraYield Cluster",
      entity: "edge-capital",
      vaults: [
        "0xF510385f5D74256bC677fbBA4e0e3079bE245Bd2",
        "0x230FB94b27da4e18f2eB6b66498aB3e9c860FAcD",
        "0xA467Ad3929E8FFdfD955f32756EC8b1522274eF2",
        "0xd3da8d58De01C99d9bB971cA284B89a2bb60798a",
      ],
    },
  ],
  [
    "frontier-pt-usde",
    {
      name: "Frontier PT-USDe",
      entity: ["euler-dao"],
      vaults: [
        "0x75C4D639067ddAf77f6BEc440e68DDdFab2C47eE",
        "0x35b6f39affA0020c1736cdC764287bfd32Ee4324",
        "0x0D10591241F67449102ACF05CD9c480CfE43154c",
      ],
      isGovernanceLimited: true,
    },
  ],
  [
    "frontier-pt-susde",
    {
      name: "Frontier PT-sUSDe",
      entity: ["euler-dao"],
      vaults: [
        "0xc3fF7A69A232239ce306dB50d63Ab2737053e24C",
        "0xd9e36ad27AfF5bBF2c65026462d45DF093554D38",
        "0x8073b76bBd1B40F1Fb2b6AEf7A920B1914Bb86AB",
      ],
      isGovernanceLimited: true,
    },
  ],
  [
    "frontier-pt-syrupusdt",
    {
      name: "Frontier PT-syrupUSDT",
      entity: ["euler-dao"],
      vaults: [
        "0x0bB995211462d10495136C6F2eCc367435481c2d",
        "0xf0A1bDf7e678144702feC359fa1A0eb50b0B8845",
      ],
      isGovernanceLimited: true,
    },
  ],
  [
    "frontier-pt-usdai",
    {
      name: "Frontier PT-USDai",
      entity: ["euler-dao"],
      vaults: [
        "0x5DccE5f1eDdf4c1Ada8Bcf2da89d4bc7fB9Dd5d2",
        "0x8539f99dBC4F437C1F71de6920369B9cD46193Ff",
        "0x98d6863fa1C247d529c94e53f521897ae9A6EBf0",
      ],
      isGovernanceLimited: true,
    },
  ],
  [
    "frontier-pt-susdai",
    {
      name: "Frontier PT-sUSDai",
      entity: ["euler-dao"],
      vaults: [
        "0xCe7120C69A77E90615A9D65C581FDAc1fd311cDC",
        "0x4bFcf2aCC5Cb79EE2A00D08EDfB81eFD37cC2Fe5",
        "0x66Ab62571Ccd31D911EeEfea85944895e30c0A3a",
      ],
      isGovernanceLimited: true,
    },
  ],
  [
    "frontier-yieldfi",
    {
      name: "Frontier YieldFi",
      entity: ["euler-dao"],
      vaults: [
        "0x1c3073EE0d6890400D2a4c7e5338001F9bf04B3D",
        "0xa1B911B8F60F87AE04Cdd4E0C4C362522927E06c",
      ],
      isGovernanceLimited: true,
    },
  ],
  [
    "telosc-fx",
    {
      name: "TelosC f(x)",
      entity: ["telosc"],
      vaults: [
        "0xC87097cc3f4633e13DADb2adaee14145cAfB348e",
        "0x38921efe4eB1dEEe78B615d968D5D66A5142b4Bf",
      ],
    },
  ],
  [
    "k3-capital-pendlend",
    {
      name: "K3 Capital Pendlend",
      entity: ["k3"],
      vaults: [
        "0x8Aec278c2fD4cc07B10A8865AEd33775f93EACe6",
        "0x527295f09Ff7c411B213B29a0DE8c816a669b3fe",
        "0x45F4ccae775BEDd6d80c368ebA87f41D8EEf1067",
        "0x9ABBc903Af7DA20325F0C4f2fE3a77AE4e1694B4",
        "0x46d2CdcAE9b0369a4b4c17BA2E34e4c7D0B2832a",
        "0x003671b7Ff5CB7F5d9B7E3a0637839D8624ca5AA",
        "0xA4e5C5B9C7685F900cf03E26340fE25af5B666C3",
        "0x3665539E0968AE000eb9E761EA89dCd9B40926Cc",
        "0xb33D091E800a731E8609E0058C67DCbcD5ad5240",
      ],
    },
  ],
  [
    "k3-plasma-trading-hub",
    {
      name: "Plasma Trading Hub",
      entity: ["k3"],
      vaults: [
        "0x990babF76399A3fd73FBFbdd4149B968CF0C2386",
        "0xf329a0A8548f6fB0aD1190c5AE6EFF0aE3959214",
      ],
    },
  ],
  [
    "frontier-elixir",
    {
      name: "Frontier Elixir",
      entity: ["euler-dao"],
      vaults: [],
      deprecatedVaults: [
        "0x5EFb3B2899a76e013040E85438cbe308870f5F50",
        "0xD59f6112375D60e45C2BA9dd5745870c1444362F",
        "0x3799251bD81925cfcCF2992F10Af27A4e62Bf3F7",
      ],
      isGovernanceLimited: true,
    },
  ],
  [
    "frontier-trevee",
    {
      name: "TelosC Trevee",
      entity: ["telosc"],
      vaults: [],
      deprecatedVaults: [
        "0x93827c26602b0573500D2eC80dB19D54EEf76BaB",
        "0x1aD2d433b5E95077EB2855EaB854B72eA9ee9d6c",
        "0xb5526491742FEe67E9E0D0D8c619A95D422fd398",
        "0x15F6ba87440E77C3dB462dC0f6ab797a63B94db4",
      ],
    },
  ],
  [
    "telosc-reservoir",
    {
      name: "TelosC Reservoir",
      description:
        "A market tailored to the Reservoir ecosystem. Governed and curated by TelosC.",
      entity: "telosc",
      vaults: [
        "0x26Fef890350FbC93FE76705370793c4136dD0Aec",
        "0x20c12fa60945Aa1806b5a24Be87b1Cc5973466ee",
      ],
    },
  ],
  [
    "k3-yuzu",
    {
      name: "Yuzu Money Cluster",
      entity: ["k3"],
      vaults: [
        "0x9d86B4fc23D8438fC4Aba58642DC35D5F64fE941",
        "0x2F33b4AE409e86c6BEa9E2Bbe98361c19F2A1f0c",
        "0xDa33Ba72A303C26515edE275a2521b469F97D71b",
        "0xFE8d21E64e0c6CFb9abF224e805452acdE8e91Fa",
        "0xfc5c4e5593A352CEDc9E5D7fD4e21b321140c345",
      ],
    },
  ],
  [
    "hyperithm-usdt0",
    {
      name: "Hyperithm USDT0",
      entity: ["hyperithm"],
      vaults: [
        "0x0a660B3Cbd7DF118501E7Bb0f2D6eC5E5e583Bf8",
        "0xD833C4C39FDd2296DeB2f8fa451e0769909B4171",
        "0x54Ff34EF2503b9636b0EbD31143b9edD124E262f",
      ],
    },
  ],
  [
    "frontier-pt-rlp",
    {
      name: "Frontier PT-RLP",
      entity: ["euler-dao"],
      vaults: [
        "0x0FBde49D0c6FA71D097C3C6465eCD6FB49ac7efa",
        "0x9CbADf620185f98dd61241242089Ff5f960aDcB8",
        "0xb23377af59d4fC95cB8330eE2834Aa8241EEed03",
      ],
      isGovernanceLimited: true,
    },
  ],
  [
    "frontier-pt-wstusr",
    {
      name: "Frontier PT-wstUSR",
      entity: ["euler-dao"],
      vaults: [
        "0x4982576311a80a3D40ac5b97195F1De6C8c879C8",
        "0x1b44853e7C3b6acBA72C0B05e08B1F6aa029ff15",
        "0x6A9E59545169BE88115671D7171967F8FbFfA0CD",
      ],
      isGovernanceLimited: true,
    },
  ],
  [
    "alphaping-yieldfi-vyusd",
    {
      name: "Alphaping YieldFi vyUSD",
      entity: ["euler-dao"],
      vaults: [
        "0xbef0b4f89Ee840CE2aC4e96ea37e807aE4F35231",
        "0x51d03b57f916EAf631892702A32a5378b93a6998",
      ],
    },
  ],
])
